import {mapGetters} from 'vuex'

const taxes = {
    ...mapGetters(['getTaxes']),
    install(Vue) {
        Vue.prototype.$setTaxes =  function(codeTax) {
            this.$store.commit('changeCodeTax', codeTax)

            let i = 0;
            for (i=0; i < this.getTaxes.length; i++)
                {
                    //console.log(i)
                 if (this.getTaxes[i].codeTax == codeTax)
                    {
                        this.$store.commit('changeActiveTaxes', this.getTaxes[i])
                    }
                }
        },
        Vue.prototype.$extractTaxes =  function(amount, totalRate, rateToExtract) {
            let tValue = amount / (1 + (totalRate / 100))
            tValue = this.$FDouble(tValue, 2)

            let sValue = this.$FDouble((tValue * rateToExtract) / 100, 2)

            return sValue //+ rateToExtract
        }
    }
}
    
export default taxes